export const sprinklerProjectionKeys = {
    all: ['sprinkler-projection'],
    list: (filters, page, sortBy, sortDirection) => [...sprinklerProjectionKeys.all, filters, page, sortBy, sortDirection]
};
